import { StyleProps } from '@chakra-ui/react';
export const Alert = {
    parts: ['container'],
    baseStyle: (props: StyleProps) => {
        const { colorScheme }: any = props;
        return {
            container: {
                background: 'unset',
                color: '#323232',
                backgroundColor: `${colorScheme}.100`,
            },
        };
    },
    variants: {},
};
